import { useCallback } from 'react';

import { useBrowserHref } from '@jane/bloom/hooks/navigation/useBrowserHref';

/**
 * Provides a function that performs a hard navigation (full page load) to a
 * relative path.
 *
 * This type of navigation is necessary around authentication during checkout, to
 * ensure the cart reloads with the newly logged-in user. It also helps establish
 * consistency for auth redirects even outside of checkout.
 */
export const useHardRedirect = () => {
  const toBrowserHref = useBrowserHref();

  return useCallback(
    (relativePath: string) => {
      window.location.href = toBrowserHref(relativePath);
    },
    [toBrowserHref]
  );
};
